import React from 'react';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

const SupportMailButton = React.createClass({
    render(){

        const mail = 'mail@domain.com';

        const userEmail = this.props.userEmail || 'N/A';
        const book = this.props.book || 'N/A';
        const chapter = this.props.chapter || 'N/A';
        const subChapter = this.props.subChapter || 'N/A';
        const exercise = this.props.exercise || 'N/A';
        const lesson = this.props.lesson || 'N/A';

        const subject = `subject= Bug: %F0%9F%90%9E - // Ticket data: usr: ${userEmail}, bookId: ${book}, chapterId: ${chapter}, subchapterId: ${subChapter}, exerciseId: ${exercise}, lessonId: ${lesson}`;
        const body = `body=`;
        return (
            <a
                href={`mailto:${mail}?${subject}&${body}`}
                className="support-link"
                style={{
                    fontSize: '10px',
                    lineHeight: '1'
                }}
            >
                <Glyphicon glyph="alert"/> Rapportera fel
            </a>
        );
    }
});

export default SupportMailButton;


/** WEBPACK FOOTER **
 ** ./src/components/SupportMailButton/SupportMailButton.js
 **/